// extracted by mini-css-extract-plugin
export default {"cover-drop-button__button":"CoverDropButton_cover-drop-button__button__175As"};